<style lang="scss">
@import "../../../../styles/_typography";
</style>

<template>
  <p :class="[baseClass, extraClass]">
    <slot>{{ text }}</slot>
  </p>
</template>

<script>
/*eslint "id-length": "off"*/

//#region Private Methods
const getDefaultClass = () => {
  return "sleek-default";
};

const getXsCLass = (component) => {
  return component.xs ? component.xs : getDefaultClass(component);
};

const getSmCLass = (component) => {
  return component.sm ? component.sm : getXsCLass(component);
};

const getMdCLass = (component) => {
  return component.md ? component.md : getSmCLass(component);
};

const getLgCLass = (component) => {
  return component.lg ? component.lg : getMdCLass(component);
};

const getXlCLass = (component) => {
  return component.xl ? component.xl : getLgCLass(component);
};
//#endregion

export default {
  name: "SleekText",
  props: {
    text: String,
    xs: String,
    sm: String,
    md: String,
    lg: String,
    xl: String,
    className: String,
  },
  computed: {
    baseClass: function () {
      const component = this;

      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return getXsCLass(component);
        case "sm":
          return getSmCLass(component);
        case "md":
          return getMdCLass(component);
        case "lg":
          return getLgCLass(component);
        case "xl":
          return getXlCLass(component);
      }
      return getDefaultClass(component);
    },
    extraClass: function () {
      return this.className ? this.className : "";
    },
  },
};
</script>
